// Pure validation functions that can be shared everywhere
export const PASSWORD_MIN_LENGTH = 15;
export const PASSWORD_MAX_LENGTH = 64;

export const validatePasswordMinLength = password => {
  return password.length >= PASSWORD_MIN_LENGTH;
};

export const validatePasswordMaxLength = password => {
  return password.length <= PASSWORD_MAX_LENGTH;
};

export const validateNoRepeatingChars = password => {
  return !/(.)\1{2,}/.test(password);
};

export const validateNoSequence = password => {
  return !/(012|123|234|345|456|567|678|789|890)/.test(password);
};

export const validatePasswordMatch = (password, confirmation) => {
  return password.length > 0 && confirmation.length > 0 && password === confirmation;
};

export const validatePassword = (password, confirmation) => {
  const state = {
    match: validatePasswordMatch(password, confirmation),
    minLength: validatePasswordMinLength(password),
    maxLength: validatePasswordMaxLength(password),
    repeating: validateNoRepeatingChars(password),
    sequence: validateNoSequence(password),
  };

  const isValid = Object.values(state).every(val => val === true);

  return { isValid, state };
};

// Shared requirements list with validator functions
export const PASSWORD_REQUIREMENTS = [
  {
    id: 'match',
    label: 'Passwords must match',
    validator: (password, confirmation) => validatePasswordMatch(password, confirmation),
    needsConfirmation: true,
  },
  {
    id: 'minLength',
    label: `Minimum ${PASSWORD_MIN_LENGTH} characters`,
    validator: password => validatePasswordMinLength(password),
    needsConfirmation: false,
  },
  {
    id: 'maxLength',
    label: `Maximum ${PASSWORD_MAX_LENGTH} characters`,
    validator: password => validatePasswordMaxLength(password),
    needsConfirmation: false,
  },
  {
    id: 'repeating',
    label: 'No repeating characters (aaa, 111)',
    validator: password => validateNoRepeatingChars(password),
    needsConfirmation: false,
  },
  {
    id: 'sequence',
    label: 'No sequences of numbers (123, 789)',
    validator: password => validateNoSequence(password),
    needsConfirmation: false,
  },
];
